// import React, { useState, useEffect } from "react";
// import * as api from "../../api/index";
// import { jwtDecode } from "jwt-decode";
// import { IoMdArrowBack } from "react-icons/io";
// import { useNavigate } from "react-router-dom";

// const OrdersPage = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState("current");
//   const [ordersData, setOrdersData] = useState({ current: [], completed: [], pending: [] });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [showReviewModal, setShowReviewModal] = useState(false);
//   const [reviewText, setReviewText] = useState("");
//   const [reviewedOrders, setReviewedOrders] = useState({});

//   // Pagination state
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const limit = 20;

//   const token = localStorage.getItem("token");
//   const decoded = jwtDecode(token);
//   const id = decoded.id || decoded._id;
//   const name = decoded.name || "";

//   const fetchOrders = async (page = 1) => {
//     try {
//       setLoading(true);
//       setError("");
//       const res = await api.Getorders(id, page, limit);

//       if (res?.data) {
//         setOrdersData({
//           current: res.data.current || [],
//           completed: res.data.completed || [],
//           pending: res.data.pending || [],
//         });

//         setTotalPages(res.data.totalPages || 1);

//         const reviewedMap = {};
//         res.data.completed?.forEach((order) => {
//           if (order.reviewed) reviewedMap[order._id] = true;
//         });
//         setReviewedOrders(reviewedMap);
//       }
//     } catch (err) {
//       setError("Failed to fetch orders. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrders(page);
//   }, [id, page]);

//   const confirmDelivery = async () => {
//     if (!selectedOrder) return;
//     try {
//       await api.confirmDelivery(selectedOrder._id);
//       setOrdersData((prev) => ({
//         ...prev,
//         current: prev.current.filter((o) => o._id !== selectedOrder._id),
//         completed: [...prev.completed, { ...selectedOrder, status: "completed" }],
//       }));
//       setSelectedOrder(null);
//       setShowModal(false);
//     } catch (err) {
//       setError("Failed to confirm delivery. Try again.");
//     }
//   };

//   const submitReview = async () => {
//     if (!reviewText.trim() || !selectedOrder) return;
//     try {
//       await api.addReview({
//         orderId: selectedOrder._id,
//         buyerId: id,
//         sellerId: selectedOrder.sellerId,
//         comment: reviewText,
//         name: name,
//       });
//       setReviewedOrders((prev) => ({ ...prev, [selectedOrder._id]: true }));
//       setReviewText("");
//       setShowReviewModal(false);
//     } catch (err) {
//       setError("Failed to submit review. Try again.");
//     }
//   };

//   const renderOrders = (orders, showDeliveredBtn = false) => (
//     <div className="space-y-4 mt-4">
//       {loading ? (
//         <p className="text-gray-500">Loading...</p>
//       ) : error ? (
//         <p className="text-red-500">{error}</p>
//       ) : orders.length === 0 ? (
//         <p className="text-gray-500">No orders found.</p>
//       ) : (
//         orders.map((order) => (
//           <div
//             key={order._id || order.id}
//             className="p-4 bg-gray-50 shadow-sm rounded-lg border border-gray-200 flex justify-between items-center"
//           >
//             <div>
//               <h3 className="font-semibold text-md">{order.item}</h3>
//               <p className="text-sm text-gray-500">{order.status}</p>
//                <p className="text-sm text-gray-500">₦{order.amount}</p>
//                <p className="text-[11px] text-gray-500">  Ordered on {new Date(order.createdAt).toLocaleDateString()}</p>
              
//             </div>

//             {showDeliveredBtn ? (
//               <button
//                 onClick={() => {
//                   setSelectedOrder(order);
//                   setShowModal(true);
//                 }}
//                 className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium"
//               >
//                 Order Received
//               </button>
//             ) : order.status === "completed" && !reviewedOrders[order._id] ? (
//               <button
//                 onClick={() => {
//                   setSelectedOrder(order);
//                   setShowReviewModal(true);
//                 }}
//                 className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-medium"
//               >
//                 Write Review
//               </button>
//             ) : reviewedOrders[order._id] ? (
//               <span className="text-orange-600 text-sm">Reviewed</span>
//             ) : null}
//           </div>
//         ))
//       )}
//     </div>
//   );

//   return (
//     <div className="flex flex-col min-h-screen bg-gray-100 p-6">
//       {/* Header */}
//       <div className="w-full mb-4">
//         <button
//           onClick={() => navigate(-1)}
//           className="flex items-center text-gray-700 hover:text-gray-900"
//         >
//           <IoMdArrowBack size={24} />
//           <span className="ml-1">Back</span>
//         </button>
//       </div>

//       <div className="max-w-5xl w-full mx-auto bg-white p-6 rounded-xl shadow-md">
//         <h1 className="text-xl font-bold mb-4 text-gray-800">My Orders</h1>

//         {/* Top Tabs */}
//         <div className="flex justify-center gap-6 border-b border-gray-200 pb-2 mb-4">
//           {["current", "completed", "pending"].map((tab) => (
//             <button
//               key={tab}
//               onClick={() => setActiveTab(tab)}
//               className={`pb-2 text-sm ${
//                 activeTab === tab
//                   ? "border-b-2 border-teal-500 text-teal-500 font-semibold"
//                   : "text-gray-500 hover:text-teal-500"
//               }`}
//             >
//               {tab === "current"
//                 ? "Current"
//                 : tab === "completed"
//                 ? "Completed"
//                 : "Pending"}
//             </button>
//           ))}
//         </div>

//         {/* Render orders for active tab */}
//         {activeTab === "current" && renderOrders(ordersData.current, true)}
//         {activeTab === "completed" && renderOrders(ordersData.completed)}
//         {activeTab === "pending" && renderOrders(ordersData.pending)}

//         {/* Pagination */}
//         <div className="flex justify-center items-center mt-4 space-x-4">
//           <button
//             disabled={page === 1}
//             onClick={() => setPage((p) => Math.max(p - 1, 1))}
//             className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//           >
//             Prev
//           </button>
//           <span className="text-sm">
//             Page {page} / {totalPages}
//           </span>
//           <button
//             disabled={page === totalPages}
//             onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
//             className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {/* Confirm Delivery Modal */}
//       {showModal && selectedOrder && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 p-4">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md">
//             <h2 className="text-xl font-bold mb-2">Confirm Delivery</h2>
//             <p className="text-gray-600 mb-4">
//               Confirm order: <span className="font-semibold">{selectedOrder.item}</span>?
//             </p>
//             <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3">
//               <button
//                 onClick={() => setShowModal(false)}
//                 className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 w-full sm:w-auto"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={confirmDelivery}
//                 className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 w-full sm:w-auto"
//               >
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Review Modal */}
//       {showReviewModal && selectedOrder && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50 p-4">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm sm:max-w-md">
//             <h2 className="text-xl font-bold mb-2">Write a Review</h2>
//             <textarea
//               value={reviewText}
//               onChange={(e) => setReviewText(e.target.value)}
//               rows="4"
//               className="w-full border rounded p-2 mb-4"
//               placeholder="Share your experience..."
//             />
//             <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-3">
//               <button
//                 onClick={() => setShowReviewModal(false)}
//                 className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 w-full sm:w-auto"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={submitReview}
//                 className="px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 w-full sm:w-auto"
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;
import React, { useState, useEffect } from "react";
import * as api from "../../api/index";
import { jwtDecode } from "jwt-decode";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FiPackage, FiBox, FiCheckCircle, FiClock, FiChevronRight, FiMapPin } from "react-icons/fi";

const OrdersPageUniversal = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("current");
  const [orders, setOrders] = useState({ current: [], completed: [], pending: [] });
  const [loading, setLoading] = useState(true);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const id = decoded.id || decoded._id;
  const role = decoded.typeofuser; 
  const limit = 20;

  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await api.GetAnyOrders(id, role, page, limit);
      setOrders({
        current: res.data.current || [],
        completed: res.data.completed || [],
        pending: res.data.pending || [],
      });
      setPages(res.data.pagination?.pages || 1);
    } catch (err) {
      setError("Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [page]);

  const confirmDelivery = async () => {
    if (!selectedOrder) return;
    try {
      setConfirmLoading(true);
      await api.confirmDelivery(selectedOrder._id);
      setOrders((prev) => ({
        ...prev,
        current: prev.current.filter((o) => o._id !== selectedOrder._id),
        completed: [...prev.completed, { ...selectedOrder, status: "completed" }],
      }));
      setSelectedOrder(null);
      setShowModal(false);
    } catch (err) {
      console.error("Failed to confirm delivery", err);
      alert("Failed to confirm delivery. Please try again.");
    } finally {
      setConfirmLoading(false);
    }
  };

  const renderActionButtons = (order) => {
    const userId = String(id);
    const buyerId = order.buyerId ? String(order.buyerId) : order.buyer?._id ? String(order.buyer._id) : null;
    const sellerId = order.sellerId ? String(order.sellerId) : order.seller?._id ? String(order.seller._id) : null;
    const isBuyer = buyerId === userId;
    const isSeller = sellerId === userId;

    if (isBuyer && order.status === "current") {
      return (
        <button
          onClick={() => {
            setSelectedOrder(order);
            setShowModal(true);
          }}
          className="bg-green-600 text-white px-4 py-2 rounded-xl text-xs font-black shadow-lg shadow-green-100 active:scale-95 transition"
        >
          Received
        </button>
      );
    }

    if (isSeller && order.status === "current") {
      return (
        <div className="flex gap-2">
          <button
            className="bg-teal-600 text-white px-3 py-2 rounded-xl text-[10px] font-black uppercase disabled:opacity-50"
            disabled={order.tracking?.ProductPicked}
            onClick={async () => {
              try {
                await api.updateOrderStage(order._id, "Product Picked");
                alert("Order marked as Picked!");
              } catch (err) {
                alert("Failed to update.");
              }
            }}
          >
            Picked
          </button>
          <button
            className="bg-orange-600 text-white px-3 py-2 rounded-xl text-[10px] font-black uppercase disabled:opacity-50"
            disabled={order.tracking?.OntheWay}
            onClick={async () => {
              try {
                await api.updateOrderStage(order._id, "On the Way");
                alert("Order marked as On the Way!");
              } catch (err) {
                alert("Failed to update.");
              }
            }}
          >
            Way
          </button>
        </div>
      );
    }

    if (role === "Rider") return <p className="text-[10px] font-black text-gray-400 uppercase">Rider</p>;
    return null;
  };

  const renderOrders = (list) => (
    <div className="space-y-4 mt-6">
      {loading ? (
        <div className="flex justify-center p-10">
          <div className="w-8 h-8 border-4 border-orange-200 border-t-orange-600 rounded-full animate-spin"></div>
        </div>
      ) : error ? (
        <div className="bg-red-50 text-red-600 p-4 rounded-2xl text-center font-bold">{error}</div>
      ) : list.length === 0 ? (
        <div className="text-center py-20 bg-white rounded-[2rem] border-2 border-dashed border-gray-100">
           <FiBox className="mx-auto text-gray-200 mb-2" size={40} />
           <p className="text-gray-400 font-bold">No {activeTab} orders</p>
        </div>
      ) : (
        list.map((order) => (
          <div key={order._id} className="bg-white p-5 rounded-[2rem] shadow-xl shadow-gray-200/50 border border-gray-50 flex justify-between items-center transition-all hover:border-orange-100">
            <div className="flex items-center gap-4">
              <div className={`p-3 rounded-2xl ${activeTab === 'completed' ? 'bg-green-50 text-green-600' : 'bg-orange-50 text-orange-600'}`}>
                {activeTab === 'completed' ? <FiCheckCircle size={20}/> : <FiPackage size={20}/>}
              </div>
              <div>
                <h3 className="font-black text-gray-900 leading-none">{order.item}</h3>
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mt-1.5 flex items-center gap-1">
                   ₦{order.amount?.toLocaleString()} <span className="text-gray-200">•</span> {new Date(order.createdAt).toLocaleDateString()}
                </p>
              </div>
            </div>
            {renderActionButtons(order)}
          </div>
        ))
      )}
    </div>
  );

  return (
    <>
      <div className="min-h-screen bg-gray-50 pb-24">
        {/* 🔝 Header */}
        <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition text-gray-700">
            <IoMdArrowBack size={24} />
          </button>
          <h1 className="text-lg font-black text-gray-900 tracking-tight">My Orders</h1>
          <div className="w-10"></div>
        </div>

        <div className="max-w-xl mx-auto p-4 sm:p-6">
          {/* 📑 Tabs */}
          <div className="flex bg-white p-1.5 rounded-2xl shadow-sm border border-gray-100">
            {["current", "completed", "pending"].map((tab) => (
              <button
                key={tab}
                className={`flex-1 py-2.5 rounded-xl text-[11px] font-black uppercase tracking-wider transition-all ${
                  activeTab === tab ? "bg-orange-600 text-white shadow-lg shadow-orange-100" : "text-gray-400 hover:text-gray-600"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {activeTab === "current" && renderOrders(orders.current)}
          {activeTab === "completed" && renderOrders(orders.completed)}
          {activeTab === "pending" && renderOrders(orders.pending)}

          {/* 📟 Pagination */}
          {pages > 1 && (
            <div className="flex justify-between items-center mt-10">
              <button disabled={page === 1} onClick={() => setPage((p) => p - 1)} className="p-3 bg-white shadow-md rounded-2xl disabled:opacity-30 transition-all active:scale-90">
                <IoMdArrowBack size={20} className="text-gray-700" />
              </button>
              <div className="text-center">
                <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Page</p>
                <span className="text-xs font-black text-gray-900">{page} / {pages}</span>
              </div>
              <button disabled={page === pages} onClick={() => setPage((p) => p + 1)} className="p-3 bg-white shadow-md rounded-2xl disabled:opacity-30 transition-all active:scale-90">
                <FiChevronRight size={20} className="text-gray-700" />
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 🛠 Modal Confirmation */}
      {showModal && selectedOrder && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 p-6">
          <div className="bg-white p-8 rounded-[2.5rem] shadow-2xl w-full max-w-sm border border-white/20 animate-in fade-in zoom-in duration-200">
            <div className="w-16 h-16 bg-green-50 text-green-600 rounded-3xl flex items-center justify-center mx-auto mb-6">
               <FiCheckCircle size={32} />
            </div>
            <h2 className="text-xl font-black text-gray-900 text-center mb-2">Confirm Delivery</h2>
            <p className="text-gray-500 text-sm text-center mb-8 font-medium">
              Have you received <span className="text-gray-900 font-bold underline decoration-orange-300">"{selectedOrder.item}"</span> in good condition?
            </p>
            <div className="flex flex-col gap-3">
              <button
                onClick={confirmDelivery}
                disabled={confirmLoading}
                className="w-full py-4 bg-green-600 text-white rounded-2xl font-black text-sm shadow-xl shadow-green-100 disabled:bg-gray-300 transition-all active:scale-[0.98]"
              >
                {confirmLoading ? "Processing..." : "Yes, Received"}
              </button>
              <button
                onClick={() => setShowModal(false)}
                className="w-full py-4 bg-gray-50 text-gray-400 rounded-2xl font-black text-sm transition-all hover:bg-gray-100"
                disabled={confirmLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrdersPageUniversal;



